
import React from 'react'
import { AuthContext } from './context'
import PropTypes from 'prop-types'

export default function AuthConsumer({ children }) {
    return (
        <AuthContext.Consumer>
            {children}
        </AuthContext.Consumer>
    )
}
AuthConsumer.propTypes = {
    children: PropTypes.func
}